import { render, staticRenderFns } from "./xykPrice.vue?vue&type=template&id=4443fa7a&scoped=true"
import script from "./xykPrice.vue?vue&type=script&lang=js"
export * from "./xykPrice.vue?vue&type=script&lang=js"
import style0 from "./xykPrice.vue?vue&type=style&index=0&id=4443fa7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4443fa7a",
  null
  
)

export default component.exports